import {Button, Typography} from 'antd';
import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import {PlusCircleOutlined} from '@ant-design/icons';

const {Text} = Typography;

export const getKeyToTranslate = (key) => {
  switch (key) {
    case 'noFormat': return 'ruleNone';
    case 'greaterThan': return 'ruleGreaterThan';
    case 'lessThan': return 'ruleLessThan';
    case 'equal': return 'ruleEqual';
    default: return 'ruleBetween';
  }
};

export const getMeasure = (value) => {
  switch (value) {
    case 'celsius': return '°C';
    case 'fahrenheit': return '°F';
    case 'others': return 'others';
    case 'chlorine': return 'chlorine';
    case 'co2': return 'co2';
    case 'atp': return 'atp';
    case 'mm': return 'mm';
    case 'cm': return 'cm';
    case 'm': return 'm';
    case 'm2': return 'm2';
    case 'm3': return 'm3';
    case 'ph': return 'Ph';
    case 'ppm': return 'ppm';
    // case 'kelvin': return 'Kelvin';
    // case 'rankine': return 'Rankine';
    // case 'réaumur': return 'Réaumur';
    // case 'rømer': return 'Rømer';
    // case 'delisle': return 'Delisle';
    default: return 'none';
  }
};

const InSituMeasureTitle = ({measure, showAddButton, nextPlace, hasEmptyPlace}) => {
  const {t} = useTranslation('templates');

  if(showAddButton && measure?.dataIndex === 'place')
    return <div className='-ml-3'>
      <Button type='link' disabled={!measure?.record?.place || !hasEmptyPlace} onClick={nextPlace} icon={<PlusCircleOutlined />}>{ t('addPlace')}</Button>
    </div>;

  return (
    <div className="w-full">
      <div className="w-full">{measure?.title}</div>

      <div className="w-full flex items-start justify-center flex-col" style={{color: 'var(--primary-color)'}}>
        <div>
          {t(getMeasure(measure?.measure)) || 'N/A'}
        </div>

        <div className="w-full flex items-center justify-start">
          <div className="mr-2">{t(getKeyToTranslate(measure?.operation))}</div>
          {measure?.operation === 'noFormat'
            ? measure?.minValue
            : measure?.operation === 'between'
              ? <Text
                style={{width: 100, color: 'var(--primary-color)'}}
                ellipsis={{tooltip: `${measure?.minValue} ${t('and')} ${measure?.maxValue}`}}
              >
                {`(${measure?.minValue} ${t('and')} ${measure?.maxValue})`}
              </Text>
              : `(${measure?.minValue || 0})`}
        </div>
      </div>
    </div>
  );};

InSituMeasureTitle.propTypes = {
  measure: PropTypes.object,
  showAddButton: PropTypes.bool,
  nextPlace: PropTypes.func,
  hasEmptyPlace: PropTypes.bool
};

export default memo(InSituMeasureTitle);
